import useUser from "@saleor/hooks/useUser";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import React, { ReactNode } from "react";

interface PermissionSectionProps {
  children: ReactNode[];
  userTypes: SmopUserTypeCode[];
}

const PermissionSection = (props: PermissionSectionProps) => {
  const { children, userTypes } = props;

  const user = useUser();

  if (children.length !== userTypes.length) {
    throw new Error("children and userTypes length must match!");
  }

  let userChild;

  for (let i = 0; i <= children.length && i <= userTypes.length; i++) {
    if (userTypes[i] === user.user.userType.code) {
      userChild = <>{children[i]}</>;
      break;
    }
  }

  if (!userChild) {
    // returns last children element in array
    userChild = <>{children[children.length - 1]}</>;
  }
  return userChild;
};

export default PermissionSection;
